(function () {
    //get the formApp module
    var formApp = angular.module('formApp');

    //set the controller to the code here - the controller uses DataServices.
    formApp.controller('incidentFormController', ['$scope', '$http', '$controller', 'DataServices', 'UtilityServices', 'ValidationService', '$log', '$location', '$routeParams', '$filter', '$anchorScroll', '$timeout', '$rootScope', 'Constants', function ($scope, $http, $controller, DataServices, UtilityServices, ValidationService, $log, $location, $routeParams, $filter, $anchorScroll, $timeout, $rootScope, Constants) {

        // Inherit parent controller
        $controller('questionController', { $scope: $scope });
        $controller('documentController', { $scope: $scope });

        if (window.location.href.indexOf('incident/1/servicedetails') > -1) {
            if (window.location.href.indexOf('DFFH') > -1) {

                for (var j = DataServices.configData.optionSets["organisation"].length - 1; j >= 0; j--) {
                    if (DataServices.configData.optionSets["organisation"][j].text == 'Department of Health') {
                        DataServices.configData.optionSets["organisation"].splice(j, 1);
                    }
                }
            }
            else {
                for (var k = DataServices.configData.optionSets["organisation"].length - 1; k >= 0; k--) {
                    if ((DataServices.configData.optionSets["organisation"][k].text == 'Department of Families, Fairness and Housing')) {
                        DataServices.configData.optionSets["organisation"].splice(k, 1);
                    }
                }
            }
            $scope.configData.optionSets["organisation"] = DataServices.configData.optionSets["organisation"];
        }

        // only get the config data if we don't have it
        DataServices.getConfigurationUsingCache(Constants.ConfigTemplate.incident, $scope.versionNumber,null, DataServices.isAuthenticated())
            .then(function (data) {
                $scope.setupTriggersAndDynamicValues();
                $scope.setSummaryErrorFocus();
                document.title = $scope.utility.getPageTitle($scope.navTabNum, $scope.pageUrl);
            });

        // default access for attaching documents (NOTE: this needs to come from the user role)
        DataServices.responseInfo.access = {
            canSaveFile: UtilityServices.isCurrentIncidentEditable(),
            canViewFile: true,
            canDeleteFile: UtilityServices.isCurrentIncidentEditable()
        };

        // Incident specific scope items
        $scope.access = DataServices.responseInfo.access;
        $scope.incidentId = DataServices.responseInfo.incidentId;
        $scope.incidentRef = DataServices.responseInfo.incidentRef;
        $scope.status = DataServices.responseInfo.status;
        $scope.statusText = DataServices.responseInfo.statusText;
        $scope.reportedDate = DataServices.responseInfo.reportedDate ? moment(DataServices.responseInfo.reportedDate).format($scope.Constants.ausDateFormat) : null;
        $scope.submittedDate = DataServices.responseInfo.submittedDate ? moment(DataServices.responseInfo.submittedDate).format($scope.Constants.ausDateFormat) : null;
        $scope.template = Constants.ConfigTemplate.incident;
        $scope.role = DataServices.responseInfo.role;

        $scope.feedbackType = Constants.FeedbackType.Privacy;

        // Updates the users role and config based on the selected organisation, serviceType and area
        // This is invoked as an exit condition so it must exist in the base controller.
        $scope.updateUserRoleAndConfig = function (successFunction, failureFunction) {

            var organisation = $scope.valueOfQuestion(null, 'sPOrgName', 'servicedetails', 0, 0, '1-1');
            var area = $scope.valueOfQuestion(null, 'sPArea', 'servicedetails', 0, 0, '1-1');
            var serviceType = $scope.valueOfQuestion(null, 'sPServiceType', 'servicedetails', 0, 0, '1-1');

            // If user is authenticated and area or service type have been changed (or entered for the first time), check the user role.
            if (DataServices.isFullyRegisteredUser() && area && serviceType &&
                (
                    !$scope.originalResponse['1-1'] ||
                    ($scope.originalResponse['1-1'] &&
                        (area !== $scope.originalResponse['1-1'][0]['servicedetails'][0]['sPArea'] ||
                            serviceType !== $scope.originalResponse['1-1'][0]['servicedetails'][0]['sPServiceType'])
                    ))) {
                    $scope.$eval(successFunction);
                
                    
            }
            else {
                $scope.$eval(successFunction);
            }
        }

        
        // Saves the current incident
        $scope.saveIncident = function (btnId) {
            // If the current page is repeating, ensure that the repeating items have been added / updated before allowing them to proceed
            if (!$scope.checkPageItemsAreSaved()) {
                return;
            }
            
            $scope.currentLoadSaveMessage = "Saving incident";
            if ($scope.isPageEditable === true && $scope.validatePage($scope.navTabNum, $scope.pageUrl, null, null, null, 'inline')) {
                // save incident for authenticated user
                if ($scope.isAuthenticated) {
                    if (!angular.equals($scope.originalResponse, $scope.responses)) {
                        saveIncidentRegisteredUser($scope.feedbackType);
                    }
                    else {
                        // No changes have been made, alert user
                        $scope.utility.openPopup('noChangesSaveNotRequired', { incidentRef: $scope.incidentRef });
                    }
                } else {
                    // Navigate to save draft page
                    DataServices.callingPage = $location.$$path.slice(1);
                    $location.path(Constants.Url.saveDraft);
                }
            }
            else {
                $scope.alertFirstError();
            }

            // save failed if we reach here.
            return null;
        }

        //Submits the incident if there are no validation errors.
        $scope.submitIncident = function () {
            if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, null, null, null, 'inline')) {
                $scope.currentLoadSubmitMessage = "Submitting Incident";

                // TODO: we need a cleaner way of injecting this captcha value.
                DataServices.responseInfo.captchaResponse = $scope.valueOfQuestion(null, 'cOCaptcha', 'consent', 0, 0);

                $scope.isSaving = true;

                DataServices.submitIncident($scope.feedbackType)
                    .then(function (response) {
                        if (response.data && response.data.status == 2) {
                            $scope.utility.openPopup('savedElsewhere', { lastUpdatedBy: response.data.lastUpdatedBy });
                        } else {
                            if (response.data && response.data.id) {
                                DataServices.trackEventsWithGA('Submit action in ' + $scope.pageUrl, 'Click Submit To Manager', 'Successfully Submitted Incident');

                                $scope.updateStatusBarInformation(response.data);

                                $scope.goToNextPage();
                            } else {
                                $scope.utility.showNotification(true, 'internalError');
                            }
                        }
                    }, function (response) {
                        $scope.utility.openPopup('errorSubmit');
                        DataServices.trackEventsWithGA('Error occured during Submiting in ' + $scope.pageUrl, 'Click Submit To Manager', 'Failed to Submit Incident');
                    })
                    .finally(function () {
                        $scope.isSaving = false;
                    });
            } else {
                $scope.moveToFirstError();
            }
        };

        // Downloads the incident PDF
        $scope.downloadPdf = function (qCode) {
            DataServices.trackEventsWithGA('Download pdf action in ' + $scope.pageUrl, 'Click Download pdf', 'Download incident pdf');

            $scope.isButtonLoading[qCode] = true;
            DataServices.viewIncidentPdf($scope.incidentId) 
                .then(function (response) {
                    var data = response && response.data;
                    try {
                        var file = new Blob([data], { type: "application/pdf" }, { name: DataServices.responseInfo.incidentRef });
                        //if (window.Blob && window.navigator.msSaveOrOpenBlob) {
                        //    saveAs(file, DataServices.responseInfo.incidentRef + '.pdf');
                        //}
                        saveAs(file, DataServices.responseInfo.incidentRef + '.pdf');
                    }
                    catch (e) {
                        $scope.utility.openPopup('errorDownloadPdf');
                    }
                    $scope.isButtonLoading[qCode] = false;
                },function () {
                    $scope.utility.openPopup('errorDownloadPdf');
                    $scope.isButtonLoading[qCode] = false;
                });
        };

        // Updates information needed for the status bar
        $scope.updateStatusBarInformation = function (response) {

            DataServices.responseInfo.incidentId = response.id;
            DataServices.responseInfo.incidentRef = response.ref;
            DataServices.responseInfo.lastUpdatedTime = response.allocatedLastUpdatedTime;
            DataServices.responseInfo.reportedDate = response.reportedDate;
            DataServices.responseInfo.submittedDate = response.submittedDate;
            DataServices.responseInfo.status = response.incidentStatus;
            DataServices.responseInfo.statusText = response.incidentStatusText;

            // Set original response to current response as update has occurred.
            $scope.originalResponse = angular.copy($scope.responses);

            $scope.incidentId = DataServices.responseInfo.incidentId;
            $scope.incidentRef = DataServices.responseInfo.incidentRef;
            $scope.lastUpdatedTime = DataServices.responseInfo.lastUpdatedTime;
            $scope.reportedDate = DataServices.responseInfo.reportedDate ? moment(DataServices.responseInfo.reportedDate).format($scope.Constants.ausDateFormat) : null;
            $scope.submittedDate = DataServices.responseInfo.submittedDate ? moment(DataServices.responseInfo.submittedDate).format($scope.Constants.ausDateFormat) : null;
            $scope.status = DataServices.responseInfo.status;
            $scope.statusText = DataServices.responseInfo.statusText;
            $scope.role = DataServices.responseInfo.role;

            if (response.formConfig && response.formConfig.configData) {
                // Explicitly set config data
                DataServices.configData = response.formConfig.configData;
                $scope.configData = response.formConfig.configData;

                DataServices.pushConfigData(response.formConfig.configData, Constants.ConfigTemplate.incident, response.formConfig.versionNumber, response.formConfig.role);
            }
        }

        // ******************************************
        // NOTE: All local functions below this line.
        // ******************************************

        // Performs the actual save for registered users
        var saveIncidentRegisteredUser = function (feedbackType) {

            if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, null, null, null, 'inline')) {
                $scope.isSaving = true;
                DataServices.saveIncidentRegisteredUser(feedbackType)
                    .then(function (response) {
                        if (response.data && response.data.status == 2) {
                            $scope.utility.openPopup('savedElsewhere',
                                { lastUpdatedBy: response.data.lastUpdatedBy });
                        } else {
                            if (response.data && response.data.id) {
                                DataServices.trackEventsWithGA('Save action in ' + $scope.pageUrl, 'Click Save Incident Registered User', 'Successfully Saved Incident');

                                $scope.updateStatusBarInformation(response.data);
                                $scope.utility.openPopup('successSaveIncident',
                                    {
                                        incidentRef: response.data.ref,
                                        oldStatusText: $scope.statusText,
                                        statusText: "Save Sucessfully"
                                        //response.data.incidentStatusText
                                    }).closed.then(function () {
                                        $rootScope.allowFormNavigation = false;
                                        $scope.returnToPrivacy();
                                    });
                            } else {
                                $scope.utility.showNotification(true, 'internalError');
                            }
                        }
                    }, function (response) {
                        $scope.utility.openPopup('errorSave');
                        DataServices.trackEventsWithGA('Error occured during Save in ' + $scope.pageUrl,
                            'Click Save Incident Registered User',
                            'Failed to Save Incident');
                    })
                    .finally(function () {
                        $scope.isSaving = false;
                    });
            }
        }

        // Performs the actual save for registered users after prompting.
        var saveIncidentAfterWarningRegisteredUser = function () {
            $scope.utility.openPopup('warnUserBeforeSave').result.then(function (result) {
                saveIncidentRegisteredUser($scope.feedbackType);
            });
        }

        // Override question controller save page item to include duplicate check.
        $scope.saveNewPageItem = function (pIndex) {
            if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, pIndex, null, null, 'inline')) {
                if ($scope.checkDuplicates($scope.pageUrl, pIndex)) {

                    $scope.setPageItemState(pIndex, Constants.RepeatingItemState.viewing);

                    // set the shadow response to equal the response as the change is being accepted
                    $scope.shadowResponse[pIndex] = angular.copy($scope.responses[$scope.pageId][pIndex]);

                    //focus the 'add' button
                    $scope.utility.focus('pageAddNewButton');
                }
            }
            else {
                $scope.alertFirstError();
            }
        }

        // Override question controller save existing page item to include duplicate check.
        $scope.saveExistingPageItem = function (pIndex) {
            if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, pIndex, null, null, 'inline')) {
                if ($scope.checkDuplicates($scope.pageUrl, pIndex)) {
                    $scope.setPageItemState(pIndex, Constants.RepeatingItemState.viewing);

                    // set the shadow response to equal the response as the change is being accepted
                    $scope.shadowResponse[pIndex] = angular.copy($scope.responses[$scope.pageId][pIndex]);

                    //focus the 'edit' button
                    $scope.utility.focus('pageEdit-' + pIndex);
                }
            }
            else {
                $scope.alertFirstError();
            }
        }

        // Checks for duplicate entries in repeating page items
        // TODO: this needs to be fixed once we work out a generic system for invoking this function after save of a repeating page or section.
        $scope.checkDuplicates = function (pageUrl, pIndex) {
            var isPageCheck = (pageUrl == "clients") || pageUrl == "othersinvolved";
            var noDuplicates = true;
            if (isPageCheck) {
                if (pageUrl == "clients" && $scope.getPageItemCount($scope.pageId) > 1) {

                    var objClients = $scope.responses[$scope.pageId];
                    var surName = $scope.responses[$scope.pageId][pIndex]["clients"][0].cDSurnameFamilyname.trim();
                    var givenName = $scope.responses[$scope.pageId][pIndex]["clients"][0].cDGivenName.trim();
                    var dob = $scope.responses[$scope.pageId][pIndex]["clients"][0].cDDOB.trim();
                    for (var i = 0; i < objClients.length; i++) {
                        if (i !== pIndex) {
                            if (surName.toLowerCase() == objClients[i]['clients'][0].cDSurnameFamilyname.toLowerCase().trim() && givenName.toLowerCase() == objClients[i]['clients'][0].cDGivenName.toLowerCase().trim() && dob == objClients[i]['clients'][0].cDDOB.trim()) {
                                $scope.utility.openPopup('duplicateClients');
                                noDuplicates = false;
                            }
                        }
                    }
                }

                if (pageUrl == "othersinvolved" && $scope.getPageItemCount($scope.pageId) > 1) {
                    var objClients = $scope.responses[$scope.pageId];
                    var surName = $scope.responses[$scope.pageId][pIndex]["othersinvolved"][0].oTSurnameFamilyName.trim();
                    var givenName = $scope.responses[$scope.pageId][pIndex]["othersinvolved"][0].oTGivenName.trim();
                    for (var i = 0; i < objClients.length - 1; i++) {
                        if (i !== pIndex) {
                            if (surName.toLowerCase() == objClients[i]['othersinvolved'][0].oTSurnameFamilyName.toLowerCase().trim() && givenName.toLowerCase() == objClients[i]['othersinvolved'][0].oTGivenName.toLowerCase().trim()) {
                                $scope.utility.openPopup('duplicateStaff');
                                noDuplicates = false;
                            }
                        }
                    }
                }
            }

            return noDuplicates;
        }

        $scope.callCancelFollowUp = function() {
            $scope.goToCancelIncident();
        }

        $scope.goToCancelIncident = function () {
            // function to call on window close on Incident form
            if (DataServices.isFullyRegisteredUser()) {

                if ($scope.status > 1) {
                    // this condition is to save only if the status is draft or nothing (not set yet)
                    $scope.returnToManagePrivacy();
                }
                else {
                    if (!angular.equals($scope.originalResponse, $scope.responses)) {
                        // for registered users
                        // display a confirmation message
                        $scope.utility.openPopup('warnUserBeforeCancelRegisteredUser').result
                            .then(function (data) {
                                if (data.result == "thirdButtonClick") {
                                    // On Yes, Save the changes
                                    $rootScope.allowFormNavigation = false;
                                    saveIncidentRegisteredUser($scope.feedbackType);
                                }
                                else {
                                    $scope.returnToPrivacy();
                                }
                            });
                    }
                    else {
                        $scope.returnToManagePrivacy();
                    }
                }
            }
            else {
                // for direct users 
                // If user chose Yes, current page is closed and landing page is displayed.
                // If user selects 'No', system stays on the current page.
                $scope.utility.openPopup('warnUserBeforeCancel').result.then(
                    function (result) {
                        // On Yes go to landing page
                        $rootScope.allowFormNavigation = false;
                        $scope.returnToPrivacy();
                    });
            }
        }

        $scope.returnToPrivacy = function () {
            $location.path(Constants.Url.privacy);
        }

        $scope.returnToManagePrivacy = function () {
            $location.path(Constants.Url.manageFeedbacks);
        }
    }]);
}());